import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateTimeHelper {

  formatDate(date: Date): string {
    if (!date) {
      return null;
    }
    const dtf = new Intl.DateTimeFormat('en-gb', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: true });
    return dtf.format(date);
  }

  formatDateShort(date: Date): string {
    if (!date) {
      return null;
    }
    const dtf = new Intl.DateTimeFormat('en-gb', { month: 'short', day: '2-digit', year: 'numeric' });
    return dtf.format(this.getDateInLocalTimeZone(date));
  }

  getDateInLocalTimeZone(date: Date): Date {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  }

  formatBrowserDate(date: Date): string {
    if (!date) {
      return null;
    }
    date = this.convertUTCDateToLocalDate(new Date(date));
    return this.formatDate(date);
  }

  convertUTCDateToLocalDate(date: Date) {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
  }

  getLocalTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

}
